import PageFrame from '../../components/PageFrame/PageFrame'
import AccountSettingsForm from './AccountSettingsForm'
import {
  useCreatePaymentMutation,
  useManagePaymentMutation,
  useSubscriptionQuery,
  useUpdateUserMutation,
} from '../../api/api'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import dayjs from 'dayjs'
import { useState } from 'react'
import SubscriptionModal from '../../components/Subscription/SubscriptionModal'

const AccountSettingsView = ({ user }) => {
  const { data: subscription, isLoading: subscriptionIsLoading } =
    useSubscriptionQuery()
  const [updateUser, { isLoading: updateIsLoading, error }] =
    useUpdateUserMutation()
  const [managePayment, { isLoading: managePaymentIsLoading }] =
    useManagePaymentMutation()

  const [createPayment, { isLoading: purchasePaymentIsLoading }] =
    useCreatePaymentMutation()
  const [subscriptionModalIsOpen, setSubscriptionModalIsOpen] = useState(false)

  const errors = error?.data?.errors || []
  const nextBillDate = dayjs.unix(subscription?.nextBillDate)
  const hasSubscription = subscription?.exists
  const pendingCancel = subscription?.pendingCancel
  const subscriptionTypes = {
    year: 'Annual',
    month: 'Monthly',
  }

  function handleSubmit(values) {
    const fields = ['name', 'displayName']
    let newValues = {}
    fields.map((field) => {
      if (values[field] !== user[field]) {
        newValues[field] = values[field]
      }
    })

    updateUser(newValues)
  }

  async function handlePurchasePlan() {
    try {
      const res = await createPayment()
      const url = res?.data?.url
      if (url) {
        window.location = url
      }
    } catch (err) {
      console.error(err)
    }
  }

  async function handleManagePayment() {
    try {
      const res = await managePayment()
      const url = res?.data?.url
      if (url) {
        window.location = url
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <PageFrame route="account" showBanner>
      <div className="p-4 h-full flex">
        <div className="min-w-[500px] max-w-[700px] h-full pr-3 w-full ">
          <div className="flex rounded-t h-[50px] px-6 items-center bg-deep">
            <h5>Account Settings</h5>
          </div>
          <div className="bg-gray-light rounded-b px-6 py-4 relative ">
            {errors?.length > 0 && (
              <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
                {errors.map(({ error }, i) => (
                  <p key={i}>{error}</p>
                ))}
              </div>
            )}
            <AccountSettingsForm user={user} onSubmit={handleSubmit} />
            {updateIsLoading ? <LoadingBlocker /> : null}
          </div>
        </div>

        <div className="min-w-[500px] max-w-[700px] h-full pl-3 w-full ">
          <div className="flex rounded-t h-[50px] px-6 items-center bg-purple-black">
            <h5>Subscription</h5>
          </div>
          <div className="bg-purple-dark rounded-b px-6 py-4 relative min-h-[100px]">
            <div className="flex">
              <div className="flex-fill mb-1">
                <label className="">Current Subscription Status</label>
                <h2 className="pl-[1px]">
                  {hasSubscription
                    ? subscriptionTypes[subscription?.interval]
                    : 'Free'}
                </h2>
                {hasSubscription && (
                  <>
                    <div className="mt-4">
                      <label>
                        {pendingCancel
                          ? 'Subscription Ends On '
                          : 'Next Billing Date'}
                      </label>

                      <div className="pl-[1px]">
                        {nextBillDate.format('dddd, MMMM D, YYYY')}
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="">
                {hasSubscription ? (
                  <button
                    className="button bg-purple-light hover:bg-purple-light-med"
                    onClick={() => handleManagePayment()}
                  >
                    Manage
                  </button>
                ) : (
                  <button
                    className="button bg-purple-light hover:bg-purple-light-med"
                    onClick={() => setSubscriptionModalIsOpen(true)}
                  >
                    Purchase
                  </button>
                )}
              </div>
            </div>
            {subscriptionIsLoading ||
            purchasePaymentIsLoading ||
            managePaymentIsLoading ? (
              <LoadingBlocker />
            ) : null}
          </div>
        </div>
        {subscriptionModalIsOpen ? (
          <SubscriptionModal
            isOpen={subscriptionModalIsOpen}
            onRequestClose={() => setSubscriptionModalIsOpen(false)}
          />
        ) : null}
      </div>
    </PageFrame>
  )
}

export default AccountSettingsView
